import { firebase } from '../config/configureFirebase';
import store from '../store/store';
import { onValue, update, push, get, onChildAdded } from "firebase/database";
import { RequestPushMsg } from '../other/NotificationFunctions';
import { FETCH_DEDUCTMONEY, FETCH_DEDUCTMONEY_SUCCESS, FETCH_DEDUCTMONEY_FAILED } from "../store/types";

export const deductFromWallet = (uid, amount, description = 'Admin Debit') => async (dispatch) => {
    const { singleUserRef, walletHistoryRef, settingsRef } = firebase;
    dispatch({ type: 'UPDATE_WALLET_BALANCE', payload: null });
    const settingsdata = await get(settingsRef);
    const settings = settingsdata.val();
    onValue(singleUserRef(uid), async (snapshot) => {
        if (snapshot.val()) {
            let walletBalance = parseFloat(snapshot.val().walletBalance);
            const pushToken = snapshot.val().pushToken;
            walletBalance = parseFloat((walletBalance - parseFloat(amount)).toFixed(settings.decimal));
            let details = {
                type: 'Debit',
                amount: parseFloat(amount),
                date: new Date().getTime(),
                txRef: description,
                transaction_id: description
            };
            await update(singleUserRef(uid), { walletBalance });
            await push(walletHistoryRef(uid), details);
            if (pushToken) {
                RequestPushMsg(
                    pushToken,
                    {
                        title: store.getState().languagedata.defaultLanguage.notification_title,
                        msg: store.getState().languagedata.defaultLanguage.wallet_updated,
                        screen: 'Wallet',
                        params: { transactionType: 'Debit' }
                    }
                );
            }
            dispatch({ type: 'UPDATE_WALLET_BALANCE_SUCCESS', payload: null });
        } else {
            dispatch({ type: 'UPDATE_WALLET_BALANCE_FAILED', payload: 'User not found' });
        }
    }, { onlyOnce: true });
};

export const fetchDeductMoney = () => (dispatch) => {
    const { deductMoneyRef } = firebase;
    dispatch({ type: FETCH_DEDUCTMONEY, payload: null });
    onValue(deductMoneyRef, snapshot => {
        if (snapshot.val()) {
            let data = snapshot.val();
            const arr = Object.keys(data).map(i => {
                return data[i]
            });
            dispatch({ type: FETCH_DEDUCTMONEY_SUCCESS, payload: arr });
        } else {
            dispatch({ type: FETCH_DEDUCTMONEY_FAILED, payload: store.getState().languagedata.defaultLanguage.no_addmoney });
        }
    });
}

export const addDeductMoney = (entry) => async (dispatch) => {
    const { deductMoneyRef } = firebase;
    dispatch({ type: FETCH_DEDUCTMONEY, payload: { entry } });
    push(deductMoneyRef, entry);
}
